"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_CLICK_ID_PARAMETERS = void 0;
exports.isAdClickIdParameter = isAdClickIdParameter;
exports.filterParameters = filterParameters;
const WHITELISTED_PARAMETERS = [
    // Google Ads click IDs and parameters
    'gad_source',
    'gad_campaign',
    'gad_campaignid',
    'gclid',
    'gbraid',
    'wbraid',
    // Meta/Facebook
    'fbclid',
    'fbp',
    'fbc',
    'fbc_source',
    // TikTok
    'ttclid',
    // Twitter/X click ID
    'twclid',
    // Microsoft Ads click ID
    'msclkid',
    // LinkedIn click ID
    'li_fat_id',
    // Reddit click ID
    'rdt_cid',
    // Pinterest click ID
    'epik',
    // Snapchat click ID
    'sccid',
    // Quora click ID
    'qclid',
    // Impact Radius click ID
    'irclid',
    // Klaviyo click ID
    '_kx',
    // Mailchimp campaign ID
    'mc_cid',
    // Generic click ID
    'clid',
    // Referral
    'r',
    // Additional UTM parameters
    'utm_landing_page',
    'utm_id',
];
/**
 * The whitelisted parameters that an ad platform's *browser* pixel reads back out of
 * `location.search` when it initialises. Every one of these MUST stay in the URL after we report it
 * to `/tracking` — pixels are injected by the tag manager after a consent decision, long after the
 * report and its URL cleanup would otherwise have run, and a pixel that finds no click ID cannot
 * match the conversion to the ad click that produced it.
 *
 * Narrower than the whitelist on purpose: `utm_*`, `dub_id`, `mc_cid` and friends are ours, not a
 * pixel's, so they are still cleaned out of the URL.
 */
exports.AD_CLICK_ID_PARAMETERS = [
    // Google Ads
    'gclid',
    'gbraid',
    'wbraid',
    // Meta/Facebook — the pixel rebuilds its `_fbc` cookie from this
    'fbclid',
    // TikTok
    'ttclid',
    // Twitter/X — uwt.js reads this and nothing else
    'twclid',
    // Microsoft Ads
    'msclkid',
    // LinkedIn
    'li_fat_id',
    // Reddit
    'rdt_cid',
    // Pinterest
    'epik',
    // Snapchat
    'sccid',
    // Impact Radius
    'irclid',
];
/**
 * Whether a parameter is a click ID a browser pixel will look for in the URL.
 */
function isAdClickIdParameter(key) {
    return exports.AD_CLICK_ID_PARAMETERS.includes(key);
}
/**
 * Filter parameters to only include whitelisted parameters and UTM parameters
 * @param parameters The parameters to filter
 * @returns The filtered parameters
 */
function filterParameters(parameters) {
    return Object.fromEntries(Object.entries(parameters).filter(([key]) => WHITELISTED_PARAMETERS.includes(key) ||
        key.startsWith('utm_')));
}
